import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';

import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule, MatTooltipDefaultOptions, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { MatChipsModule } from '@angular/material/chips';
import { MatBadgeModule } from '@angular/material/badge';
import { LoadingOverlayModule } from '../shared/loading-overlay/loading-overlay.module';

import {
  NgxMatDatetimepicker,
  NgxMatDatepickerInput,
  NgxMatDatepickerToggle,
  NgxMatTimepickerComponent,
  NgxMatDatepickerActions,
  NgxMatDatepickerApply,
  NgxMatDatepickerCancel,
  NgxMatDatepickerClear,
} from '@ngxmc/datetime-picker';

export const OtherOptions: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchGestures: 'auto',
  position: 'below',
  touchendHideDelay: 0,
  disableTooltipInteractivity: true,
}

@NgModule({
  declarations: [],
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: OtherOptions }
  ],
  imports: [
    CommonModule,
    ClipboardModule,
    MatCardModule,
    MatBottomSheetModule,
    MatInputModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatTableModule,
    MatListModule,
    MatSelectModule,
    MatRadioModule,
    MatSortModule,
    MatMenuModule,
    MatSidenavModule,
    MatIconModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatDialogModule,
    MatButtonModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatRippleModule,
    MatTooltipModule,
    MatChipsModule,
    MatBadgeModule,
    MatTabsModule,
    NgxMatDatetimepicker,
    NgxMatDatepickerInput,
    NgxMatDatepickerToggle,
    NgxMatTimepickerComponent,
    NgxMatDatepickerActions,
    NgxMatDatepickerApply,
    NgxMatDatepickerCancel,
    NgxMatDatepickerClear,
    MatToolbarModule,
    MatTreeModule,
    CdkTableModule,
    CdkTreeModule,
    LoadingOverlayModule
  ],
  exports: [
    MatInputModule,
    ClipboardModule,
    MatCardModule,
    MatButtonToggleModule,
    MatBottomSheetModule,
    MatAutocompleteModule,
    MatTableModule,
    MatListModule,
    MatSelectModule,
    MatRadioModule,
    MatSortModule,
    MatMenuModule,
    MatChipsModule,
    MatBadgeModule,
    MatSidenavModule,
    MatIconModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatDialogModule,
    MatButtonModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatRippleModule,
    MatTooltipModule,
    MatTabsModule,
    NgxMatDatetimepicker,
    NgxMatDatepickerInput,
    NgxMatDatepickerToggle,
    NgxMatTimepickerComponent,
    NgxMatDatepickerActions,
    NgxMatDatepickerApply,
    NgxMatDatepickerCancel,
    NgxMatDatepickerClear,
    MatToolbarModule,
    MatTreeModule,
    CdkTableModule,
    CdkTreeModule,
    LoadingOverlayModule
  ],
})
export class AngularMaterialModule { }
